import { cn } from '@/utils/format';
import { cva, VariantProps } from 'cva';
import * as React from 'react';

const inputVariants = cva(
  [
    'flex w-full',
    'rounded-sm',
    'text-md file:text-sm file:font-medium sm:text-sm sm:leading-6',
    'text-foreground/95 placeholder:text-muted-foreground',
    'ring-0 ring-inset focus:ring-1 focus:ring-inset focus:ring-primary-600',
    'disabled:cursor-not-allowed disabled:text-foreground/40',
  ],
  {
    variants: {
      variant: {
        default: 'shadow-xs border border-foreground/30 bg-background',
        secondary: 'shadow-xs border-0 bg-background',
        outline:
          'border border-input bg-transparent file:border-0 file:bg-transparent date:border-0 date:bg-transparent',
        destructive: 'border border-red-500 bg-background',
        ghost:
          'bg-transparent border-0 ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      },
      size: {
        xs: '',
        sm: '',
        md: 'h-10 px-3 py-2',
        lg: '',
        xl: '',
      },
    },
    compoundVariants: [],
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  },
);

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ variant, size, className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { inputVariants, Input };
